import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeStringEnum } from '../../utils/typeboxHelpers';
import { assetTableSchema } from '../asset/assetTableSchema';

const optionalScoreSchema = Type.Optional(makeStringEnum(['A+', 'A', 'B', 'C', 'D', 'NVT']));

export const crowBeeldKwaliteitPaths = {
    '/api/surveys/{surveyId}/elements/crowBeeldkwaliteit/objectTree': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'crowBeeldkwaliteitControllers.getElements',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    units: Type.Array(
                                        Type.Object({
                                            icons: Type.Array(
                                                Type.Object({
                                                    iconName: Type.String(),
                                                    color: Type.String(),
                                                }),
                                            ),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    icons: Type.Array(
                                                        Type.Object({
                                                            iconName: Type.String(),
                                                            color: Type.String(),
                                                        }),
                                                    ),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.String(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.String(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    icons: Type.Array(
                                        Type.Object({
                                            iconName: Type.String(),
                                            color: Type.String(),
                                        }),
                                    ),
                                    id: Type.String(),
                                    inspectionStandardData: Type.String(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/crowBeeldkwaliteit': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('unitId')],
        get: {
            operationId: 'crowBeeldkwaliteitControllers.getUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                crowScore: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'crowBeeldkwaliteitControllers.updateUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                crowScore: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            crowScore: optionalScoreSchema,
                            remarks: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/manifestations/{manifestationId}/inspectionStandardData/crowBeeldkwaliteit': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('manifestationId')],
        get: {
            operationId: 'crowBeeldkwaliteitControllers.getManifestation',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                crowScore: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'crowBeeldkwaliteitControllers.updateManifestation',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                crowScore: optionalScoreSchema,
                                remarks: Type.Optional(Type.String()),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            crowScore: optionalScoreSchema,
                            remarks: Type.Optional(Type.String()),
                        }),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/elements/crowBeeldkwaliteit/report': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'crowBeeldkwaliteitControllers.getReportData',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    units: Type.Array(
                                        Type.Object({
                                            assets: Type.Array(
                                                Type.Pick(assetTableSchema, [
                                                    'description',
                                                    'id',
                                                    'type',
                                                    'unitId',
                                                    'filenameThumbnail',
                                                    'filenameMidSize',
                                                    'name',
                                                ]),
                                            ),
                                            surveyInspectionStandardData: Type.Object({
                                                crowScore: optionalScoreSchema,
                                                remarks: Type.Optional(Type.String()),
                                            }),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    assets: Type.Array(
                                                        Type.Pick(assetTableSchema, [
                                                            'description',
                                                            'id',
                                                            'type',
                                                            'manifestationId',
                                                            'filenameThumbnail',
                                                            'filenameMidSize',
                                                            'name',
                                                        ]),
                                                    ),
                                                    surveyInspectionStandardData: Type.Object({
                                                        crowScore: optionalScoreSchema,
                                                        remarks: Type.Optional(Type.String()),
                                                    }),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.String(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.String(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    crowScore: optionalScoreSchema,
                                    id: Type.String(),
                                    inspectionStandardData: Type.String(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
} as const;
